import React from "react";
import { useTranslation } from "react-i18next";

const SearchInput = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={t(placeholder)}
        className="w-full px-6 py-2 pr-10 text-gray-700 bg-white border border-gray-300 rounded-md outline-none focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-taction"
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <svg
          className="w-5 h-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default SearchInput;
